import { ConfigProvider, theme } from "antd";
import ruRU from "antd/lib/locale/ru_RU";
import { ThemeProvider, useTheme } from "next-themes";
import { useEffect, useState, type ReactNode } from "react";
import { Provider } from "react-redux";

import { MessagesProvider } from "@/providers/MessagesProvider";
import store from "@/store";

interface ProvidersProps {
	children: ReactNode;
}

const ThemeConfigProvider = ({ children }: { children: ReactNode }) => {
	const { theme: resolvedThemes } = useTheme();
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	const algorithmTheme =
		resolvedThemes === "dark" ? theme.darkAlgorithm : theme.defaultAlgorithm;

	// Кастомные токены для тёмной темы
	const customTheme = {
		algorithm: algorithmTheme,
		token: {
			// Глобальные токены для тёмной темы
			...(resolvedThemes === "dark" && {
				colorBorder: "#7E8DA9",
				colorBgContainer: "#3D475C",
			}),
		},
		components: {
			// Компонент-специфичные токены для Button
			Button: {
				...(resolvedThemes === "dark" && {
					// Для outlined
					colorBorder: "#7E8DA9",
					colorBgContainer: "#3D475C",
				}),
			},
		},
	};

	if (!mounted) {
		return (
			<Provider store={store}>
				<MessagesProvider>{children}</MessagesProvider>
			</Provider>
		);
	}

	return (
		<ConfigProvider locale={ruRU} theme={customTheme}>
			<Provider store={store}>
				<MessagesProvider>{children}</MessagesProvider>
			</Provider>
		</ConfigProvider>
	);
};

export const Providers = ({ children }: ProvidersProps) => {
	return (
		<ThemeProvider attribute="class" enableSystem={false} defaultTheme="light">
			<ThemeConfigProvider>{children}</ThemeConfigProvider>
		</ThemeProvider>
	);
};
